module.exports = __webpack_public_path__ + "f3c12a99ebe255699b7b5023da42d770.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/desktop-chart.svg
// module id = 77
// module chunks = 0